import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {},
    stock: "",
    systemConfig: {},
    accountBank: {},
    orderConfirmInfo:{
      receiverAddress: "",
      receiverName: "",
      receiverPhone: "",
    }
  },
  mutations: {
    // 设置用户信息
    setUserObj (state, obj) {
      state.userInfo = Object.assign(state.userInfo, obj)
    },
    setSystemObj (state, obj) {
      state.systemConfig = Object.assign(state.systemConfig, obj)
    },
    setAccountBankObj (state, obj) {
      state.accountBank = Object.assign(state.accountBank, obj)
    },
    // 订单确认页面信息
    setOrderConfirmInfo (state, obj){
      if(obj.productId){
        this.commit("resetOrderConfirmInfo");
      }
      state.orderConfirmInfo = Object.assign(state.orderConfirmInfo, obj)
    },
    // 清空订单确认页面信息
    resetOrderConfirmInfo (state){
      state.orderConfirmInfo = {
        receiverAddress: "",
        receiverName: "",
        receiverPhone: "",
      }
    }
  },
  actions: {
    setUserInfo({ commit }, data) {
      commit('setUserObj', data)
    },
    setSystemConfig({ commit }, data) {
      commit('setSystemObj', data)
    },
    setAccountBank({ commit }, data) {
      commit('setAccountBankObj', data)
    }
  }
})
